module.exports = __webpack_public_path__ + "static/media/xlsx-file.cd6a758a.svg";